<template>
   <main class="home">
      <section class="container mb-4">
         <div class="row">
            <div class="col-12 col-md-6 order-2 order-md-1 primo-piano d-flex flex-column">
               <!--div class="category-top mt-4 mb-3 d-none d-md-block ">
                  <a class="category font-weight-semibold text-uppercase">{{intro.area}}</a>
                  <span class="date float-right text-uppercase">{{intro.modified}}</span>
               </div-->
               <h1 class="h2 mt-5">
                  {{intro.titolo}}
                  <!--router-link :to="{ path: '/notizie/'+intro.slug, params: { slug:'notizie-e-eventi', _slug:intro.slug} }" :title="intro.titolo">
                     {{intro.titolo}}
                  </router-link-->
               </h1>
               <p>
                  <vue-markdown :source="intro.corpo"></vue-markdown>
               </p>

               <!-- div class="head-tags mt-auto" v-if="intro.argomenti && intro.argomenti.length > 0">
                  <h6 class="x-small font-weight-semibold d-none d-md-block sr-only">Tag</h6>
                  <div class="align-items-center  mt-4 mt-md-0">
                     <argomento v-for="(argomento, val) in intro.argomenti" :tag="argomento" :key="val"></argomento>
                  </div>
                  <div class="separator border-top mt-3 pt-3 d-flex">
                     <router-link :to="{ path: '/notizie/'+intro.slug, params: { slug:'notizie', _slug:intro.slug} }" :title="intro.titolo" class="read-more">
                        <span class="read-more">Leggi di più</span><svg class="icon">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="img/sprite.svg#it-arrow-right"></use></svg>
                     </router-link>
                     <div class="d-flex ml-auto">
                        <shareArea :hasLabel="false" />
                     </div>                  
                  </div>
               </div -->
            </div>
            <div class="col-12 col-md-6 order-1 order-md-2">
               <div class="img-responsive-wrapper" v-if="intro.image !== undefined && intro.image.length > 0">
                  <div class="img-responsive">
                     <figure class="img-wrapper" >
                        <img :src="intro.image[0].immagine" :alt="intro.image[0].didascalia" class="position-relative">
                     </figure>
                  </div>
               </div>
            </div>
         </div>
      </section>

      <section v-for="blocco, index in blocchi" :key="blocco.id" :id="`card_${index}`" style="display:none">
         <div class="container">
            <div class="row">
               <h3 class="col-12 pt-3"><router-link  :to="blocco.url" :title="'vai alla pagina: `{${blocco.titolo}}`'" class="text-body">{{blocco.titolo}}</router-link></h3>
               <div v-if="blocco.modello == 15">
                  <card v-for="(item, index2) in blocco.items" :key="`${index2}`" :id="`${item.id}`" :news="{item}" :path="blocco.url"/> 
               </div>
               <div v-if="blocco.modello == 9">
                  <imgcard v-for="(item, index2) in blocco.items" :key="`${index2}`" :id="`${item.id}`" :articolo="item"/>
                  <eventcard v-for="(item, index2) in blocco.items" :key="`${index2}`" :id="`${item.id}`" :event="{item}" :path="blocco.url"/> 
               </div>
            </div>
         </div>
      </section>


      <section id="area-notizie" class="pt-3 py-1">
         <div class="container">
            <div class="row">
               <h3 class="col-12 pt-3"><router-link  :to="{ name: 'Notizie' }" :title="'vai alla pagina: Notizie'" class="text-body">Notizie</router-link></h3>
               <card v-for="(item) in notizie" :key="`${item.id}`" :id="`${item.id}`" :news="{item}" :path="'/notizie-e-eventi'"/> 
            </div>
         </div>
      </section>
   
      <section id="area-specializzazione" class="pt-3 py-1">
         <div class="container">
            <div class="row">
               <h3 class="col-12 pt-3"><router-link :to="{ name: 'Aree di specializzazione'}" :title="'vai alla pagina: Aree di specializzazione'" class="text-body">Aree di specializzazione</router-link></h3>
               <imgcard v-for="(item) in specializzazione" :key="item.id" :id="item.idFonteDati" :articolo="item"/>
            </div>
         </div>                  
      </section>

   </main>
</template>
<script>
import { getPost, getAssociatedPostsIDs, getPosts, parseArticolo, getPostsIDs } from './../service';
//import ShareArea from "@/components/ShareArea";
//import argomento from "@/components/Arguments.vue";
import axios from 'axios';
import VueMarkdown from 'vue-markdown';
import card from "@/components/Card";
import imgcard from "@/components/ImgCard";
import eventcard from "@/components/CardEvent";


export default {
   name: "home",
   title: 'Home',
   components: {
      VueMarkdown,
      //ShareArea,
     // argomento,
      card,
      imgcard,
      eventcard
   },   

   data() {
      return {
         errors: [],
         intro: {},
         notizie: [],
         specializzazione: [],
         areas: [],
         blocchi: {

         },
      }
   },
   methods:{
      loadPost: async function(id, tipo) {
         this.post = undefined;
         try {                     
            const result = await getPost(id, tipo);
            this.intro = parseArticolo(result);
         } catch (ex) {
            console.log('failed loadPost');
            this.intro = null;
         }
      },

      loadSubcategories: async function(items){         
         let ids = items.map(x => x.idFonteDati);
         try {
            let categories = await getAssociatedPostsIDs(ids);
            this.notizie = categories.posts;            
         } catch (ex) {
            console.log('failed loadSubcategories');
            this.post = null;
         }
      },

      loadPosts: async function(sezione) {
         this.specializzazione = null;
         try {                     
            const result = await getPosts(sezione);            
            this.specializzazione = result.posts;
         } catch (ex) {
            console.log('failed loadPost');
            this.specializzazione = null;
         }
      },

      loadItems: function(items){         
         let ids = items.map(x => x.idFonteDati);
         try {
            let categories = getAssociatedPostsIDs(ids);
            this.notizie = categories.posts;            
         } catch (ex) {
            console.log('failed loadSubcategories');
            this.post = null;
         }
      },   

      setBlocchi: function(blocchi){
         let tempBlocchi = [];          
         for(let blocco in blocchi){
            if(blocchi[blocco].tipo != 'SINGOLO_CONTENUTO' && blocchi[blocco].attivo){            
               tempBlocchi.push(this.creaBlocco(blocchi[blocco]));                              
            }
         }
         this.blocchi = tempBlocchi;
         console.log(5);
      },

      creaBlocco: function(objBlock){
         return{         
            titolo: objBlock.titolo,
            url: objBlock.linkUrl,
            modello: objBlock.modello,
            items: this.loadArticles(objBlock.items != undefined ? objBlock.items : objBlock.filtriList[0].valoreFiltro)
            /*items: async() => {
                  let ids = objBlock.items.map(x => x.idFonteDati);
                  console.log(ids);
                  //return getPostsIDs(ids);
             }*/
         }
      },

      loadArticles: async function(items){         
         try {
            if(typeof items != 'object'){
               console.log(2.1);
               const result = await getPosts(items.filtriList[0].valoreFiltro);
               return result.posts;
            }
            else{
               console.log(2.2);
               let ids = items.map(x => x.idFonteDati);
               let categories = await getPostsIDs(ids);               
               return categories.posts;
            }            
         } catch (ex) {
            return null;
         }
      },      
   },

   async created() {
      try {
         const response = await axios.get(process.env.VUE_APP_HP_LAYOUT);         
         this.loadPost(response.data[0].bloccoPaginaList[0].items[0].idFonteDati, response.data[0].bloccoPaginaList[0].items[0].tipoContenuto);
         this.loadSubcategories(response.data[0].bloccoPaginaList[1].items);
         this.loadPosts(response.data[0].bloccoPaginaList[2].filtriList[0].valoreFiltro);
         await this.setBlocchi(response.data[0].bloccoPaginaList);
         //this.$root.setMainMenu(this.response.menuList);
      } catch (e) {
         this.errors.push(e)
      }
   }
};
</script>